"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const IconComponent_1 = tslib_1.__importDefault(require("../components/IconComponent"));
const MneListItem_1 = tslib_1.__importDefault(require("../components/MneListItem"));
const MneListItemButton_1 = tslib_1.__importDefault(require("../components/MneListItemButton"));
const MneListItemIcon_1 = tslib_1.__importDefault(require("../components/MneListItemIcon"));
const MneListItemText_1 = tslib_1.__importDefault(require("../components/MneListItemText"));
const getNavigationProps_1 = require("../utils/getNavigationProps");
const MenuItem = ({ variant, iconId, href, label, open, hideIcon = false, ...rest }) => (react_1.default.createElement(MneListItem_1.default, { key: label, ...rest.ListItemProps },
    react_1.default.createElement(MneListItemButton_1.default, { ...(0, getNavigationProps_1.getNavigationProps)(href, variant) },
        !hideIcon && (react_1.default.createElement(MneListItemIcon_1.default, { ...rest.ListItemIconProps },
            react_1.default.createElement(IconComponent_1.default, { iconId, fontSize: "small" }))),
        react_1.default.createElement(MneListItemText_1.default, { open,
            primary: label,
            inset: Boolean(!iconId),
            primaryTypographyProps: { variant: "body1" },
            ...rest.ListItemTextProps }),
        variant === "external" && open && (react_1.default.createElement(MneListItemIcon_1.default, { sx: { mr: 1 } },
            react_1.default.createElement(IconComponent_1.default, { iconId: "externalApp" }))))));
exports.default = MenuItem;
